import AcceptOrderBannerPage from "@faire/prototype-playground/workspace/mm/accept-order-banner";
import BrandAnalyticsPage from "@faire/prototype-playground/workspace/mm/brand-analytics";
import MobileProductsPagePage from "@faire/prototype-playground/workspace/mm/mobile-products-page";
import NewBrandBenefitsPage from "@faire/prototype-playground/workspace/mm/new-brand-benefits";
import NotificationsStressTestPage from "@faire/prototype-playground/workspace/mm/notifications-stress-test";
import OneClickReferralPage from "@faire/prototype-playground/workspace/mm/one-click-referral";
import RetailerAnalyticsPage from "@faire/prototype-playground/workspace/mm/retailer-analytics";
import RetailerInsightsPage from "@faire/prototype-playground/workspace/mm/retailer-insights";
import { lazy } from "react";
import { Route, Switch } from "react-router-dom";
import { withCompass } from "../../components/compass/withCompass";
import BrandOnboardingHappyPathPage from "@faire/prototype-playground/workspace/mm/brand-onboarding-happy-path";

const DemoCarawayPage = withCompass(
  () => import("@faire/prototype-playground/workspace/mm/demo-caraway/Page")
);

const DemoAwayPage = withCompass(
  () => import("@faire/prototype-playground/workspace/mm/demo-away/Page")
);

const BrandPortalVisionPage = lazy(
  () => import("../../pages/BrandPortalVisionPage")
);
const R2BReferralsNowOnFairePage = withCompass(
  () => import("../../pages/R2BReferralsNowOnFairePage")
);
const BrandPortalFuturePage = lazy(
  () => import("../../pages/BrandPortalFuturePage")
);
const BrandPortalExplorationPage = lazy(
  () => import("../../pages/BrandPortalExplorationPage")
);
const BuildYourShopPage = lazy(() => import("../../pages/BuildYourShopPage"));
const BrandPortalNewBrandsPage = lazy(
  () => import("../../pages/BrandPortalNewBrandsPage")
);
const GenZBrandPortalV2Page = lazy(
  () => import("../../pages/GenZBrandPortalV2Page")
);

export function MaggieMurphyRoutes() {
  return (
    <Switch>
      <Route path="/mm/accept-order-banner" component={AcceptOrderBannerPage} />
      <Route path="/mm/brand-portal-vision" component={BrandPortalVisionPage} />
      <Route
        path="/mm/r2b-referrals-now-on-faire"
        component={R2BReferralsNowOnFairePage}
      />
      <Route path="/mm/brand-portal-future" component={BrandPortalFuturePage} />
      <Route
        path="/mm/brand-portal-exploration"
        component={BrandPortalExplorationPage}
      />
      <Route path="/mm/build-your-shop" component={BuildYourShopPage} />
      <Route path="/mm/demo-caraway" component={DemoCarawayPage} />
      <Route path="/mm/demo-away" component={DemoAwayPage} />
      <Route
        path="/mm/brand-portal-new-brands"
        component={BrandPortalNewBrandsPage}
      />
      <Route
        path="/mm/genz-brand-portal-v2"
        component={GenZBrandPortalV2Page}
      />
      <Route
        path="/mm/mobile-products-page"
        component={MobileProductsPagePage}
      />
      <Route path="/mm/one-click-referral" component={OneClickReferralPage} />
      <Route path="/mm/brand-analytics" component={BrandAnalyticsPage} />
      <Route path="/mm/brand-onboarding-happy-path" component={BrandOnboardingHappyPathPage} />
      <Route path="/mm/new-brand-benefits" component={NewBrandBenefitsPage} />
      <Route path="/mm/retailer-analytics" component={RetailerAnalyticsPage} />
      <Route path="/mm/retailer-insights" component={RetailerInsightsPage} />
      <Route
        path="/mm/notifications-stress-test"
        component={NotificationsStressTestPage}
      />
    </Switch>
  );
}

export const slug = "mm";
